<script>
  import ActiveUsers from '../components/ActiveUsers.svelte'
  import TweetCharts from '../components/TweetCharts.svelte'
  import { scale, fade } from 'svelte/transition'
  import { onMount } from 'svelte'
  let tweets = []
  let hashtag = ' '
  let getTweetsSet = false
  async function getTweets(ht) {
    let url = `https://mediahack.co.za/looting/api/get-tweets.php?ht=${ht}&limit=10`
    console.log(url)

    await fetch(url)
      .then((response) => response.json())
      .then((response) => {
        tweets = response
        console.log(response)

        getTweetsSet = true
      })
  }
  onMount(() => {
    getTweets('')
  })

  $: getTweets(hashtag)
</script>

<div class="tl-wrap">
  <section class="top-wrap">
    <ActiveUsers label="#KZNShutdown" />
  </section>

  <div class="charts">
    <section>
      <div class="chart-intro">
        The chart below is based on a random selection of around 40,000 tweets
        using a combination of hashtags including #JacobZuma,
        #RamaphosaMustFall, #FreeJacobZuma and others. The selection is not
        comprehensive but more illustrative.
      </div>
    </section>
    <TweetCharts />
  </div>

  <!--  Top Tweets -->

  <div class="wrap">
    <div style="width: 100%; text-align: center;"><h1>Top Tweets</h1></div>
    <div class="tweet-options">
      <button
        class={hashtag === 'JacobZuma' ? 'selected-button' : ''}
        on:click={() => (hashtag = 'JacobZuma')}>#JacobZuma</button
      >
      <button
        class={hashtag === 'FreeJacobZuma' ? 'selected-button' : ''}
        on:click={() => (hashtag = 'FreeJacobZuma')}>#FreeJacobZuma</button
      >
      <button
        class={hashtag === 'PhoenixMassacre' ? 'selected-button' : ''}
        on:click={() => (hashtag = 'PhoenixMassacre')}>#PhoenixMassacre</button
      >
      <button
        class={hashtag === 'RamaphosaMustFall' ? 'selected-button' : ''}
        on:click={() => (hashtag = 'RamaphosaMustFall')}
        >#RamaphosaMustFall</button
      >
    </div>
    <div class="timeline-wrap">
      {#each tweets as tweet}
        <div
          in:scale
          out:fade
          class="tweet {tweet.type === 'media' ? 'media' : ''}"
        >
          <div class="tweet-meta">
            <div
              class="avatar"
              style="background-image: {tweet.twitter_profile_pic !== ''
                ? 'url(' + tweet.twitter_profile_pic + ')'
                : 'url(https://mediahack.co.za/looting/api/twitter-default.png)'}"
            />
            <div class="tweet-user">
              @{tweet.username}
              <div class="tweet-date">{tweet.datetime}</div>
            </div>
          </div>
          <div>
            <div class="tweet-content">{@html tweet.tweet}</div>
            <div class="retweet">
              Retweets
              <img
                class="retweet"
                src="/images/retweet.svg"
                alt="Retweet"
              />{tweet.retweets}
            </div>
          </div>
        </div>
      {/each}
    </div>
  </div>
</div>

<style>
  .selected-button {
    background: hotpink;
  }
  .top-wrap {
    margin-top: 100px;
    margin-bottom: 100px;
  }
  .tweet-options {
    width: 96%;
    max-width: 700px;
    text-align: center;
    margin-left: auto;
    margin-right: auto;
    margin-bottom: 20px;
  }
  .tweet-user {
    font-weight: 700;
    font-size: 1.1rem;
  }
  .tweet-date {
    font-size: 0.9rem;
    color: #fff;
  }
  .tweet-meta {
    display: grid;
    grid-template-columns: auto 3fr;
  }
  .wrap {
    margin-top: 100px;
  }
  .tweet {
    font-size: 0.9rem;
    padding: 10px;
    border-radius: 10px;
    /* border: solid 1px lightgray; */
    margin: 10px;
    color: rgb(230, 230, 230);
    background: rgb(36, 36, 36);
    border: solid 1px rgb(139, 139, 139);
  }

  .avatar {
    width: 50px;
    height: 50px;
    background: url(/images/twitter-default.png) no-repeat center center;
    -webkit-background-size: cover;
    -moz-background-size: cover;
    -o-background-size: cover;
    background-size: cover;
    border-radius: 50px;
  }
  .timeline-wrap {
    display: grid;
    grid-template-columns: 1fr 1fr;
    width: 90%;

    max-width: 800px;
    margin-left: auto;
    margin-right: auto;
  }
  .avatar {
    margin-right: 10px;
  }
  .retweet {
    font-size: 0.9rem;
    font-weight: 400;
    margin-top: 5px;
    text-transform: uppercase;
  }
  img.retweet {
    width: 20px;
    margin-right: 5px;
  }
  .media {
    /* border: solid 3px dodgerblue; */
    /* border-top: solid 3px dodgerblue; */
    background: rgb(211, 180, 79);
    color: #000;
  }
  button {
    padding: 10px 20px;
    /* border: solid 2px gray; */
    border: none;
    background: rgb(77, 77, 77);
    color: #fff;
    border-radius: 20px;
    cursor: pointer;
    margin-top: 10px;
  }
  .tl-wrap {
    background: rgb(43, 43, 43);
  }
  circle {
    stroke: #fff;
    stroke-width: 2px;
  }
</style>
